import PropTypes from "prop-types";
import {
  TextField,
  FormControl,
  FormLabel,
  FormHelperText,
  useTheme,
} from "@mui/material";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useMemo, useState } from "react";

const InputDatePicker = ({
  id,
  label,
  initialValue,
  error,
  onChange,
  isDisabled = false,
  placeholder = "",
}) => {
  const theme = useTheme();
  const [value, setValue] = useState("");
  console.log("label");
  useMemo(() => {
    setValue(initialValue ?? "");
  }, [initialValue]);

  const handleChange = (newValue) => {
    const dateFormatted = moment(moment(newValue.$d)).format("MM-DD-YYYY");
    setValue(dateFormatted);
    onChange(dateFormatted);
  };

  return (
    <FormControl fullWidth disabled={isDisabled}>
      {label && label !== "" && (
        <FormLabel error={!!error && error !== ""} htmlFor={id}>
          {label}
        </FormLabel>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value !== "" ? moment(value).format("MM/DD/YYYY") : null}
          onChange={handleChange}
          OpenPickerButtonProps={{
            sx: {
              color: theme.palette.primary.main,
            },
          }}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                error={!!error}
                inputProps={{
                  ...params.inputProps,
                  placeholder,
                  readOnly: true,
                }}
                placeholder=""
              />
            );
          }}
          disabled={isDisabled}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText error id={id}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

InputDatePicker.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  initialValue: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default InputDatePicker;
